<p-dialog [(visible)]="currentDisplay" [modal]="true" [closable]="false" [responsive]="true"
 [style]="{width: '80vw'}" styleClass="add-edit-account body-p-dialog" [appendTo]="'body'">
    <ng-template pTemplate="header"  appendTo="body">
        <div style="display: flex; justify-content: space-between; width: 100%;">
            <h5 class="p-mb-0">
                {{ headerTitle }}
            </h5>
            <div class="p-ml-auto p-d-flex p-ai-center">
                <div *ngIf="!['add','update','copy'].includes(this.crudType) && viewLeadData" class="p-mr-2">
                    <strong> Created by {{ viewLeadData?.createdByUserName }}</strong> {{ viewLeadData?.createdDate | localDate: 'date' }}
                </div>
                <button pButton
                    (click)="showEditAccountFromView()"
                    *ngIf="!isEditAccount && editPermission && selectedAccount?.statusId === 1 && !selectedAccount?.isConvertedToAccount"
                    style="margin-left: auto;" class="p-button-text p-button-rounded p-pt-0" icon="pi pi-pencil">
                </button>
                <button pButton pRipple
                    (click)="onCancelAddEditView()"
                    class="p-button-text p-button-rounded p-pt-0" icon="pi pi-times">
                </button>
            </div>

        </div>
    </ng-template>

    <ng-template pTemplate="content">
        <ng-container *ngIf="!detailsLoadingFailed">
            <form *ngIf="checkedFields" [formGroup]="leadForm" autocomplete="off">

                <div *ngIf="templateSections && templateSections[0]" class="header">
                    <h5>
                        {{ templateSections[0]?.name }}
                    </h5>
                </div>

                <div class="card">
                    <div formArrayName="leadContacts" *ngIf="this.crudType === 'add' || this.crudType === 'update'  || this.crudType === 'copy'; else contactDetailsViewBlock">
                        <ng-container *ngFor="let contact of formControl?.leadContacts?.controls; let i = index;">
                            <ng-container [formGroup]="contact">
                                <ng-container formGroupName="contact">
                                    <div class="p-field p-grid">
                                        <div class="p-col-12 p-lg-2" *ngIf="checkedFields.Title">
                                            <label class="p-mb-2">
                                                {{ checkedFields.Title.labelName }}
                                                @if(checkedFields?.Title?.description){
                                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                       pTooltip="{{checkedFields.Title?.description}}"
                                                       tooltipPosition="top">
                                                    </i>
                                                }
                                            </label>
                                            <p-dropdown [options]="salutations" name="title" optionLabel="name" optionValue="id" formControlName="salutationId" placeholder="Select Title">
                                            </p-dropdown>
                                        </div>

                                        <div *ngIf="checkedFields.FirstName" class="p-col-12 p-formgrid p-lg-4">
                                            <label class="p-mb-2">
                                                {{ checkedFields.FirstName?.labelName }}
                                                <span style="color: red;">*</span>
                                                @if(checkedFields?.FirstName?.description){
                                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                       pTooltip="{{checkedFields.FirstName?.description}}"
                                                       tooltipPosition="top">
                                                    </i>
                                                }
                                            </label>
                                            <input pInputText type="text" formControlName="firstName" />
                                            <small class="p-invalid p-mt-2" *ngIf="formControl?.contact?.get('firstName')?.errors?.required &&
                                                formControl?.contact?.get('firstName').touched">
                                                First name is required
                                            </small>
                                            <small class="p-invalid p-mt-2" *ngIf="formControl?.contact?.get('firstName')?.errors?.maxlength && formControl?.contact?.get('firstName').touched">
                                                Max 100 characters
                                            </small>
                                            <small class="p-invalid p-mt-2" *ngIf="formControl?.contact?.get('firstName')?.errors?.pattern && formControl?.contact?.get('firstName').touched">
                                                Colon (:) is not allowed
                                            </small>
                                        </div>

                                        <div class="p-col-12 p-lg-2" *ngIf="checkedFields.MiddleInitial">
                                            <label class="p-mb-2">
                                                {{ checkedFields.MiddleInitial?.labelName }}
                                                @if(checkedFields?.MiddleInitial?.description){
                                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                       pTooltip="{{checkedFields.MiddleInitial?.description}}"
                                                       tooltipPosition="top">
                                                    </i>
                                                }
                                            </label>
                                            <input pInputText type="text" formControlName="middleName" />
                                            <small class="p-invalid p-mt-2" *ngIf="formControl?.contact?.get('middleName')?.errors?.maxlength && formControl?.contact?.get('middleName').touched">
                                                Max 100 characters
                                            </small>
                                            <small class="p-invalid p-mt-2" *ngIf="formControl?.contact?.get('middleName')?.errors?.pattern && formControl?.contact?.get('middleName').touched">
                                                Colon (:) is not allowed
                                            </small>
                                        </div>

                                        <div class="p-col-12 p-lg-4" *ngIf="checkedFields.LastName">
                                            <label class="p-mb-2">
                                                {{ checkedFields.LastName?.labelName }}
                                                @if(checkedFields?.LastName?.description){
                                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                       pTooltip="{{checkedFields.LastName?.description}}"
                                                       tooltipPosition="top">
                                                    </i>
                                                }
                                            </label>
                                            <input pInputText type="text" formControlName="lastName" id="lastName" name="lastName" />
                                            <small id="error-help" class="p-invalid" *ngIf="formControl.contact.get('lastName')?.errors?.required &&
                                                formControl.contact.get('lastName').touched">
                                                Last name is required
                                            </small>
                                            <small class="p-invalid p-mt-2" *ngIf="formControl?.contact?.get('lastName')?.errors?.maxlength && formControl?.contact?.get('lastName').touched">
                                                Max 100 characters
                                            </small>
                                            <small class="p-invalid p-mt-2" *ngIf="formControl?.contact?.get('lastName')?.errors?.pattern && formControl?.contact?.get('lastName').touched">
                                                Colon (:) is not allowed
                                            </small>
                                        </div>
                                    </div>

                                    <div class="p-field p-formgrid p-grid multiline">
                                        <div class="p-col-12 p-lg-6" *ngIf="checkedFields.WorkEmail || checkedFields.HomeEmail ||
                                                checkedFields.CE1 || checkedFields.CE2">
                                            <div class="p-inputgroup p-grid p-mb-2">
                                                <label class="p-col-12">
                                                    Email
                                                    @if(checkedFields.WorkEmail || checkedFields.HomeEmail ||
                                                    checkedFields.CE1 || checkedFields.CE2){
                                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                               pTooltip="Primary contact email address."
                                                               tooltipPosition="top">
                                                            </i>
                                                        }
                                                </label>
                                            </div>

                                            <div class="p-grid" *ngIf="checkedFields.WorkEmail">
                                                <div class="p-col-12">
                                                    <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                        <i [pTooltip]="checkedFields.WorkEmail?.labelName"
                                                            tooltipPosition="top" class="pi pi-briefcase">
                                                        </i>
                                                        <input pInputText type="email" #workemailn="ngModel"
                                                            pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                                            [(ngModel)]="workEmail.tempValue"
                                                            [leadId]="leadForm.value?.id"
                                                            [asyncEmailValidator]="leadEmails[0]?.email?.emailAddress"
                                                            (blur)="contactEmailCheck(workEmail,workemailn)"
                                                            [ngModelOptions]="{standalone: true}"
                                                            placeholder="{{checkedFields.WorkEmail?.labelName}}" />
                                                    </span>
                                                </div>
                                                <div class="p-pl-2 p-mt-2"
                                                *ngIf="workemailn.errors?.pattern || workEmail.tempValue.length > 100 || workemailn.errors?.emailExists">
                                                    <div *ngIf="workEmail.tempValue.length > 100">
                                                        <small class="p-invalid">
                                                            Max 100 characters
                                                        </small>
                                                    </div>
                                                    <div *ngIf="workemailn.errors?.pattern">
                                                        <small class="p-invalid">
                                                            Invalid email format
                                                        </small>
                                                    </div>
                                                    <div *ngIf="workemailn.errors?.emailExists">
                                                        <small class="p-invalid">
                                                            This email already added, please enter another email
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-grid" *ngIf="checkedFields.HomeEmail">
                                                <div class="p-col-12">
                                                    <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                        <i [pTooltip]="checkedFields.HomeEmail?.labelName"
                                                            tooltipPosition="top" class="pi pi-home">
                                                        </i>
                                                        <input pInputText type="email" #homeemailn="ngModel"
                                                            pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                                            [(ngModel)]="homeEmail.tempValue"
                                                            [leadId]="leadForm.value?.id"
                                                            [asyncEmailValidator]="leadEmails[0]?.email?.emailAddress||workEmail?.tempValue"
                                                            (blur)="contactEmailCheck(homeEmail,homeemailn)"
                                                            [ngModelOptions]="{standalone: true}"
                                                            placeholder="{{checkedFields.HomeEmail?.labelName}}" />
                                                    </span>
                                                </div>
                                                <div class="p-pl-2 p-mt-2"
                                                *ngIf="homeEmail.tempValue.length > 100 || homeemailn.errors?.pattern || homeemailn.errors?.emailExists">
                                                    <div *ngIf="homeEmail.tempValue.length > 100">
                                                        <small class="p-invalid">
                                                            Max 100 characters
                                                        </small>
                                                    </div>
                                                    <div *ngIf="homeemailn.errors?.pattern">
                                                        <small class="p-invalid">
                                                            Invalid email format
                                                        </small>
                                                    </div>
                                                    <div *ngIf="homeemailn.errors?.emailExists">
                                                        <small class="p-invalid">
                                                            This email already added, please enter another email
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-grid" *ngIf="checkedFields.CE1">
                                                <div class="p-col-12">
                                                    <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                        <i [pTooltip]="checkedFields.CE1?.labelName" tooltipPosition="top"
                                                            class="pi pi-envelope">
                                                        </i>
                                                        <input pInputText type="email" #ceone="ngModel"
                                                            pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                                            [(ngModel)]="ce1.tempValue"
                                                            (blur)="contactEmailCheck(ce1,ceone)"
                                                            [ngModelOptions]="{standalone: true}"
                                                            placeholder="{{checkedFields.CE1?.labelName}}" />
                                                    </span>
                                                </div>
                                                <div class="p-pl-2 p-mt-2"
                                                *ngIf="ce1.tempValue.length > 100 || ceone.invalid">
                                                    <div *ngIf="ce1.tempValue.length > 100">
                                                        <small class="p-invalid">
                                                            Max 100 characters
                                                        </small>
                                                    </div>
                                                    <div *ngIf="ceone.invalid">
                                                        <small class="p-invalid">
                                                            Invalid email format
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-grid" *ngIf="checkedFields.CE2">
                                                <div class="p-col-12">
                                                    <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                        <i [pTooltip]="checkedFields.CE2?.labelName" tooltipPosition="top"
                                                            class="pi pi-envelope">
                                                        </i>
                                                        <input pInputText type="email" #cetwo="ngModel"
                                                            pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                                            [(ngModel)]="ce2.tempValue"
                                                            (blur)="contactEmailCheck(ce2,cetwo)"
                                                            [ngModelOptions]="{standalone: true}"
                                                            placeholder="{{checkedFields.CE2?.labelName}}" />
                                                    </span>
                                                </div>
                                                <div class="p-pl-2 p-mt-2"
                                                *ngIf="ce2.tempValue.length > 100 || cetwo.invalid">
                                                    <div *ngIf="ce2.tempValue.length > 100">
                                                        <small class="p-invalid">
                                                            Max 100 characters
                                                        </small>
                                                    </div>
                                                    <div *ngIf="cetwo.invalid">
                                                        <small class="p-invalid">
                                                            Invalid email format
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="p-col-12 p-lg-6" *ngIf="checkedFields.WorkPhone || checkedFields.HomePhone ||
                                        checkedFields.MobilePhone || checkedFields.CP1 || checkedFields.CP2">
                                            <div class="p-inputgroup p-grid p-mb-2">
                                                <label class="p-col-4">
                                                    Select Country
                                                </label>
                                                <label class="p-col-8" style="padding-left:0.75rem">
                                                    Phone
                                                    @if(checkedFields.WorkPhone || checkedFields.HomePhone ||
                                                    checkedFields.MobilePhone || checkedFields.CP1 || checkedFields.CP2){
                                                        <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                                        pTooltip="Primary contact phone number"
                                                        tooltipPosition="top">
                                                        </i>
                                                    }
                                                </label>
                                            </div>
                                            <div class="p-grid" *ngIf="checkedFields.WorkPhone">
                                                <div class="p-col-12 p-lg-4 ">
                                                    <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                                        optionLabel="CountryName"
                                                        optionValue="CountryName"
                                                        [autoDisplayFirst]="false"
                                                        [ngModelOptions]="{standalone:true}"
                                                        [(ngModel)]="workPhone.phone.country"
                                                        placeholder="Select Country"
                                                        (onChange)="onCountrySelect($event, workPhone)"
                                                        class="inline custom-height" appendTo="body">
                                                    </p-dropdown>
                                                </div>
                                                <div class="p-col-12 p-lg-8">
                                                    <div class="p-inputgroup">
                                                        <span class="p-inputgroup-addon">+{{workPhone.phone.code}}</span>
                                                        <p-inputMask *ngIf="phoneNumberFormat && !workPhone?.phone?.maskingDisabled" [mask]="phoneNumberFormat" #workPhonen="ngModel" [(ngModel)]="workPhone.tempValue"
                                                        [ngModelOptions]="{standalone: true}" [slotChar]="'_'" [autoClear]="false" class="w-100" placeholder="{{checkedFields.WorkPhone.labelName}}"
                                                        pTooltip="{{checkedFields.WorkPhone.labelName}}" tooltipPosition="top"></p-inputMask>
                                                        <input *ngIf="!(phoneNumberFormat && !workPhone?.phone?.maskingDisabled)" pInputText type="text" #workPhonen="ngModel" [(ngModel)]="workPhone.tempValue"
                                                        [ngModelOptions]="{standalone: true}" placeholder="{{checkedFields.WorkPhone.labelName}}"
                                                        pTooltip="{{checkedFields.WorkPhone.labelName}}" tooltipPosition="top" />
                                                    </div>
                                                <div>
                                                    <div class="p-pl-1 p-mt-1" *ngIf="workPhonen?.invalid">
                                                        <small class="p-invalid">
                                                            Invalid phone format
                                                        </small>
                                                    </div>
                                                    <div class="p-pl-1 p-mt-1" *ngIf="workPhone.tempValue | phoneValidation">
                                                        <small class="p-invalid">
                                                            Max 50 characters
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>

                                            <div class="p-grid" *ngIf="checkedFields.HomePhone">
                                                <div class="p-col-12 p-lg-4 ">
                                                    <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                                        optionLabel="CountryName"
                                                        optionValue="CountryName"
                                                        [autoDisplayFirst]="false"
                                                        [ngModelOptions]="{standalone:true}"
                                                        [(ngModel)]="homePhone.phone.country"
                                                        placeholder="Select Country"
                                                        (onChange)="onCountrySelect($event, homePhone)"
                                                        class="inline custom-height" appendTo="body">
                                                    </p-dropdown>
                                                </div>
                                                <div class="p-col-12 p-lg-8">
                                                    <div class="p-inputgroup">
                                                        <span class="p-inputgroup-addon">+{{homePhone.phone.code}}</span>
                                                        <p-inputMask *ngIf="phoneNumberFormat && !homePhone?.phone?.maskingDisabled" [mask]="phoneNumberFormat" type="text" #homePhonen="ngModel" [(ngModel)]="homePhone.tempValue"
                                                        [ngModelOptions]="{standalone: true}" [slotChar]="'_'" [autoClear]="false" class="w-100"
                                                        placeholder="{{checkedFields.HomePhone.labelName}}"
                                                        pTooltip="{{checkedFields.HomePhone.labelName}}" tooltipPosition="top"></p-inputMask>
                                                        <input *ngIf="!(phoneNumberFormat && !homePhone?.phone?.maskingDisabled)" pInputText type="text" #homePhonen="ngModel" [(ngModel)]="homePhone.tempValue"
                                                        [ngModelOptions]="{standalone: true}" placeholder="{{checkedFields.HomePhone.labelName}}"
                                                        pTooltip="{{checkedFields.HomePhone.labelName}}" tooltipPosition="top" />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="p-pl-1 p-mt-1" *ngIf="homePhonen?.invalid">
                                                        <small class="p-invalid">
                                                            Invalid phone format
                                                        </small>
                                                    </div>
                                                    <div class="p-pl-1 p-mt-1" *ngIf="homePhone.tempValue | phoneValidation">
                                                        <small class="p-invalid">
                                                            Max 50 characters
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-grid" *ngIf="checkedFields.MobilePhone">
                                                <div class="p-col-12 p-lg-4">
                                                    <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                                        optionLabel="CountryName"
                                                        optionValue="CountryName"
                                                        [autoDisplayFirst]="false"
                                                        [ngModelOptions]="{standalone:true}"
                                                        [(ngModel)]="mobilePhone.phone.country"
                                                        placeholder="Select Country"
                                                        (onChange)="onCountrySelect($event, mobilePhone)"
                                                        class="inline custom-height" appendTo="body">
                                                    </p-dropdown>
                                                </div>
                                                <div class="p-col-12 p-lg-8">
                                                    <div class="p-inputgroup">
                                                        <span class="p-inputgroup-addon">+{{mobilePhone.phone.code}}</span>
                                                        <p-inputMask *ngIf="phoneNumberFormat && !mobilePhone?.phone?.maskingDisabled" [mask]="phoneNumberFormat" type="text" #mobilePhonen="ngModel" [(ngModel)]="mobilePhone.tempValue"
                                                        [ngModelOptions]="{standalone: true}" [slotChar]="'_'" [autoClear]="false" class="w-100"
                                                        placeholder="{{checkedFields.MobilePhone.labelName}}"
                                                        pTooltip="{{checkedFields.MobilePhone.labelName}}" tooltipPosition="top"></p-inputMask>
                                                        <input *ngIf="!(phoneNumberFormat && !mobilePhone?.phone?.maskingDisabled)" pInputText type="text"  #mobilePhonen="ngModel" [(ngModel)]="mobilePhone.tempValue"
                                                        [ngModelOptions]="{standalone: true}" placeholder="{{checkedFields.MobilePhone.labelName}}"
                                                        pTooltip="{{checkedFields.MobilePhone.labelName}}" tooltipPosition="top" />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="p-pl-1 p-mt-1" *ngIf="mobilePhonen?.invalid">
                                                        <small class="p-invalid">
                                                            Invalid phone format
                                                        </small>
                                                    </div>
                                                    <div class="p-pl-1 p-mt-1" *ngIf="mobilePhone.tempValue | phoneValidation">
                                                        <small class="p-invalid">
                                                            Max 50 characters
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-grid" *ngIf="checkedFields.CP1">
                                                <div class="p-col-12 p-lg-4">
                                                    <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                                        optionLabel="CountryName"
                                                        optionValue="CountryName"
                                                        [autoDisplayFirst]="false"
                                                        [ngModelOptions]="{standalone:true}"
                                                        [(ngModel)]="cp1.phone.country"
                                                        placeholder="Select Country"
                                                        (onChange)="onCountrySelect($event, cp1)"
                                                        class="inline custom-height" appendTo="body">
                                                    </p-dropdown>
                                                </div>
                                                <div class="p-col-12 p-lg-8">
                                                    <div class="p-inputgroup">
                                                        <span class="p-inputgroup-addon">+{{cp1.phone.code}}</span>
                                                        <p-inputMask *ngIf="phoneNumberFormat && !cp1?.phone?.maskingDisabled" [mask]="phoneNumberFormat" type="text" #cpone="ngModel" [(ngModel)]="cp1.tempValue"
                                                        [ngModelOptions]="{standalone: true}" [slotChar]="'_'" [autoClear]="false" class="w-100"
                                                        placeholder="{{checkedFields.CP1.labelName}}"
                                                        pTooltip="{{checkedFields.CP1.labelName}}" tooltipPosition="top"></p-inputMask>
                                                        <input *ngIf="!(phoneNumberFormat && !cp1?.phone?.maskingDisabled)" pInputText type="text" #cpone="ngModel" [(ngModel)]="cp1.tempValue"
                                                        [ngModelOptions]="{standalone: true}" placeholder="{{checkedFields.CP1.labelName}}"
                                                        pTooltip="{{checkedFields.CP1.labelName}}" tooltipPosition="top" />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="p-pl-1 p-mt-1" *ngIf="cpone?.invalid">
                                                        <small class="p-invalid">
                                                            Invalid phone format
                                                        </small>
                                                    </div>
                                                    <div class="p-pl-1 p-mt-1" *ngIf="cp1.tempValue | phoneValidation">
                                                        <small class="p-invalid">
                                                            Max 50 characters
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-grid" *ngIf="checkedFields.CP2">
                                                <div class="p-col-12 p-lg-4">
                                                    <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                                        optionLabel="CountryName"
                                                        optionValue="CountryName"
                                                        [autoDisplayFirst]="false"
                                                        [ngModelOptions]="{standalone:true}"
                                                        [(ngModel)]="cp2.phone.country"
                                                        placeholder="Select Country"
                                                        (onChange)="onCountrySelect($event, cp2)"
                                                        class="inline custom-height" appendTo="body">
                                                    </p-dropdown>
                                                </div>
                                                <div class="p-col-12 p-lg-8">
                                                    <div class="p-inputgroup">
                                                        <span class="p-inputgroup-addon">+{{cp2.phone.code}}</span>
                                                        <p-inputMask *ngIf="phoneNumberFormat && !cp2?.phone?.maskingDisabled" [mask]="phoneNumberFormat" type="text" #cptwo="ngModel" [(ngModel)]="cp2.tempValue"
                                                        [ngModelOptions]="{standalone: true}" [slotChar]="'_'" [autoClear]="false" class="w-100"
                                                        placeholder="{{checkedFields.CP2.labelName}}"
                                                        pTooltip="{{checkedFields.CP2.labelName}}" tooltipPosition="top"></p-inputMask>
                                                        <input *ngIf="!(phoneNumberFormat && !cp2?.phone?.maskingDisabled)" pInputText type="text" #cptwo="ngModel" [(ngModel)]="cp2.tempValue"
                                                        [ngModelOptions]="{standalone: true}" placeholder="{{checkedFields.CP2.labelName}}"
                                                        pTooltip="{{checkedFields.CP2.labelName}}" tooltipPosition="top" />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="p-pl-1 p-mt-1" *ngIf="cptwo?.invalid">
                                                        <small class="p-invalid">
                                                            Invalid phone format
                                                        </small>
                                                    </div>
                                                    <div class="p-pl-1 p-mt-1" *ngIf="cp2.tempValue | phoneValidation">
                                                        <small class="p-invalid">
                                                            Max 50 characters
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <ng-container>
                                        <div class="p-field p-formgrid p-grid multiline">
                                            <div class="p-col-12 p-lg-6" *ngIf="checkedFields.ContactTwitter ||
                                                    checkedFields.ContactFacebook || checkedFields.ContactLinkedin ||
                                                    checkedFields.ContactInstagram || checkedFields.ContactWebsite">
                                                <div class="p-inputgroup p-mb-2">
                                                    <label style="width: 100%;">
                                                        Social Profile
                                                        @if(checkedFields?.SocialProfile.description){
                                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                               pTooltip="{{checkedFields.SocialProfile?.description}}"
                                                               tooltipPosition="top">
                                                            </i>
                                                        }
                                                    </label>
                                                </div>

                                                <div class="p-grid" *ngIf="checkedFields.ContactTwitter">
                                                    <div class="p-col-12">
                                                        <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                            <i [pTooltip]="checkedFields.ContactTwitter?.labelName"
                                                                tooltipPosition="top" class="fa fa-twitter">
                                                            </i>
                                                            <input pInputText type="text"
                                                                [(ngModel)]="contactTwitter.tempValue"
                                                                [ngModelOptions]="{standalone: true}" />
                                                            <div *ngIf="contactTwitter.tempValue.length > 500">
                                                                <small class="p-invalid">
                                                                    Max 500 characters
                                                                </small>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="p-grid" *ngIf="checkedFields.ContactFacebook">
                                                    <div class="p-col-12">
                                                        <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                            <i [pTooltip]="checkedFields.ContactFacebook?.labelName"
                                                                tooltipPosition="top" class="fa fa-facebook-official">
                                                            </i>
                                                            <input pInputText type="text"
                                                                [(ngModel)]="contactFacebook.tempValue"
                                                                [ngModelOptions]="{standalone: true}" />
                                                            <div *ngIf="contactFacebook.tempValue.length > 500">
                                                                <small class="p-invalid">
                                                                    Max 500 characters
                                                                </small>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="p-grid" *ngIf="checkedFields.ContactLinkedin">
                                                    <div class="p-col-12">
                                                        <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                            <i [pTooltip]="checkedFields.ContactLinkedin?.labelName"
                                                                tooltipPosition="top" class="fa fa-linkedin">
                                                            </i>
                                                            <input pInputText type="text"
                                                                [(ngModel)]="contactLinkedin.tempValue"
                                                                [ngModelOptions]="{standalone: true}" />
                                                            <div *ngIf="contactLinkedin.tempValue.length > 500">
                                                                <small class="p-invalid">
                                                                    Max 500 characters
                                                                </small>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="p-grid" *ngIf="checkedFields.ContactInstagram">
                                                    <div class="p-col-12">
                                                        <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                            <i [pTooltip]="checkedFields.ContactInstagram?.labelName"
                                                                tooltipPosition="top" class="fa fa-instagram">
                                                            </i>
                                                            <input pInputText type="text"
                                                                [(ngModel)]="contactInstagram.tempValue"
                                                                [ngModelOptions]="{standalone: true}" />
                                                            <div *ngIf="contactInstagram.tempValue.length > 500">
                                                                <small class="p-invalid">
                                                                    Max 500 characters
                                                                </small>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="p-grid" *ngIf="checkedFields.ContactWebsite">
                                                    <div class="p-col-12">
                                                        <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                                            <i [pTooltip]="checkedFields.ContactWebsite?.labelName"
                                                                tooltipPosition="top" class="fa fa-desktop">
                                                            </i>
                                                            <input pInputText type="text"
                                                                [(ngModel)]="contactWebsite.tempValue"
                                                                [ngModelOptions]="{standalone: true}" />
                                                            <div *ngIf="contactWebsite.tempValue.length > 500">
                                                                <small class="p-invalid">
                                                                    Max 500 characters
                                                                </small>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-col-12 p-lg-6" *ngIf="checkedFields.ProfileImage">
                                                <div class="p-grid">
                                                    <div class="p-col-12">
                                                        <label class="p-mb-2">
                                                            {{ checkedFields.ProfileImage?.labelName }}
                                                            @if(checkedFields?.ProfileImage?.description){
                                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                                pTooltip="{{checkedFields.ProfileImage?.description}}"
                                                                tooltipPosition="top">
                                                                </i>
                                                            }
                                                        </label>
                                                        <p-fileUpload [ngClass]="{ 'disabledbutton': !isEditAccount }" customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose" accept="image/*" [showUploadButton]="false" [disabled]="!isEditAccount" [showCancelButton]="false" (onSelect)="uploadProfilePic($event.files)">
                                                            <ng-template pTemplate="file"></ng-template>
                                                            <ng-template pTemplate="content">
                                                                <ng-container *ngIf="selectedcontactProfileImages">
                                                                    <ng-container *ngFor="let profileImg of selectedcontactProfileImages; let i = index;">
                                                                        <ng-container *ngIf="profileImg.attachment && profileImg.attachment.statusId === 1">
                                                                            <div class="p-fileupload-row">
                                                                                <button pButton icon="fa fa-download" (click)="downloadFile(profileImg.attachment.name, profileImg.attachment.content, profileImg.attachment.location)" class="p-button-link p-px-0 p-py-0" label=""></button>
                                                                                <ng-container *ngIf="profileImg.attachment && profileImg.attachment.content && profileImg.attachment.content.startsWith('data') else localImage">
                                                                                    <img src="{{profileImg.attachment.content}}" width="100" alt="card" />
                                                                                </ng-container>
                                                                                <ng-template #localImage>
                                                                                    <img [src]="profileImg.attachment.location" width="100" alt="card" />
                                                                                </ng-template>
                                                                                <div>{{ profileImg.attachment.name }}</div>
                                                                                <div>{{ (profileImg.attachment.sizeInBytes / 1024).toFixed(2) + ' KB' }}</div>
                                                                                <div>
                                                                                    <button icon="pi pi-times" pButton [disabled]="!isEditAccount" (click)="removeProfileImg(i)" type="button" icon="pi pi-times"></button>
                                                                                </div>
                                                                            </div>
                                                                        </ng-container>
                                                                    </ng-container>
                                                                </ng-container>
                                                            </ng-template>
                                                        </p-fileUpload>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>

                                    <div class="p-field p-formgrid p-grid multiline" *ngIf="checkedFields.ContactDesignation">
                                        <div class="p-col-12 p-lg-6">
                                            <label class="p-mb-2">
                                                {{ checkedFields.ContactDesignation?.labelName }}
                                                @if(checkedFields?.ContactDesignation?.description){
                                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                       pTooltip="{{checkedFields.ContactDesignation?.description}}"
                                                       tooltipPosition="top">
                                                    </i>
                                                }
                                            </label>
                                            <p-dropdown [options]="contactRoles" formControlName="contactRoleId" name="contactRole" optionLabel="name" optionValue="id" placeholder="Select {{ checkedFields.ContactDesignation?.labelName }}" appendTo="body" filter="true">
                                            </p-dropdown>
                                        </div>
                                    </div>
                                    <div class="p-field p-formgrid p-grid multiline" *ngIf="checkedFields.ContactRoles">
                                        <div class="p-col-12 p-lg-6">
                                            <label class="p-mb-2">
                                                {{ checkedFields.ContactRoles?.labelName }}
                                                @if(checkedFields?.ContactRoles?.description){
                                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                       pTooltip="{{checkedFields.ContactRoles?.description}}"
                                                       tooltipPosition="top">
                                                    </i>
                                                }
                                            </label>
                                            <p-multiSelect [options]="newContactRoles" formControlName="contactRoles" filter="true"  dataKey="roleId"
                                            optionLabel="roleName" placeholder="Select {{ checkedFields.ContactRoles?.labelName }}" appendTo="body">
                                        </p-multiSelect>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </div>

                    <ng-template #contactDetailsViewBlock>
                        <div class="p-field p-grid p-mb-0">
                            <ng-container *ngIf="checkedFields.ContactID && viewLeadData.contactSequenceNumber">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.ContactID?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.contactSequenceNumber }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.Title && viewLeadData.contactSalutation">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.Title?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.contactSalutation }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.FirstName && viewLeadData.contactFirstName">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.FirstName?.labelName }}
                                            <span style="color: red;">*</span>
                                        </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.contactFirstName }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.MiddleInitial && viewLeadData.contactMiddleName">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.MiddleInitial?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.contactMiddleName }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.LastName && viewLeadData.contactLastName">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.LastName?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.contactLastName }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.WorkEmail && viewLeadData.workEmailAddress">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.WorkEmail?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.workEmailAddress }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.HomeEmail && viewLeadData.homeEmailAddress">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.HomeEmail?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.homeEmailAddress }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.CE1 && viewLeadData.ce1EmailAddress">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.CE1?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.ce1EmailAddress }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.CE2 && viewLeadData.ce2EmailAddress">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.CE2?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.ce2EmailAddress }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.WorkPhone && viewLeadData.workPhone?.number">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.WorkPhone?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.workPhone.number | phoneNumber: viewLeadData.workPhone.countryCode}} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.HomePhone && viewLeadData.homePhone?.number">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.HomePhone?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.homePhone.number | phoneNumber: viewLeadData.homePhone.countryCode}} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.MobilePhone && viewLeadData.mobilePhone?.number">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.MobilePhone?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.mobilePhone.number | phoneNumber: viewLeadData.mobilePhone.countryCode}} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.CP1 && viewLeadData.cp1Phone?.number">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.CP1?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.cp1Phone.number | phoneNumber: viewLeadData.cp1Phone.countryCode}} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.CP2 && viewLeadData.cp2Phone?.number">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.CP2?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.cp2Phone.number | phoneNumber: viewLeadData.cp2Phone.countryCode}} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.ContactWebsite && viewLeadData.contactWebsite">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.ContactWebsite?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.contactWebsite }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.ContactTwitter && viewLeadData.contactTwitter">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.ContactTwitter?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.contactTwitter }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.ContactFacebook && viewLeadData.contactFacebook">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.ContactFacebook?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.contactFacebook }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.ContactLinkedin && viewLeadData.contactLinkedin">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.ContactLinkedin?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.contactLinkedin }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.ContactInstagram && viewLeadData.contactInstagram">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.ContactInstagram?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.contactInstagram }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.ProfileImage && viewLeadData.profileImages?.length">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.ProfileImage?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <div *ngFor="let image of viewLeadData.profileImages" [pTooltip]="image.name" style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                                        <img [src]="image.downloadLink" width="100" alt="card" /> {{ image.name | shorten:15 }} ({{ image.sizeInKb + ' KB' }})
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.ContactDesignation && viewLeadData.jobFunction">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.ContactDesignation?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.jobFunction }} </p>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="checkedFields.ContactRoles && viewLeadData.jobFunctions">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.ContactRoles?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData.jobFunctions }} </p>
                                </div>
                            </ng-container>
                        </div>
                    </ng-template>
                </div>

                <p-tabView [(activeIndex)]="tabIndex" *ngIf="this.crudType === 'add' || this.crudType === 'update' || this.crudType === 'copy'; else leadViewBlock">
                    <p-tabPanel [header]="templateSections && templateSections[1]?.name">
                        <div class="card" *ngIf="leadForm && checkedFields">
                            <div class="p-field p-grid">
                                <div class="p-col-12 p-lg-6" >
                                    <label class="p-mb-2"> {{ checkedFields.LeadIDNo?.labelName  }} <span style="color: red;">*</span>
                                        @if(checkedFields?.LeadIDNo?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.LeadIDNo?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <input *ngIf="this.crudType === 'add' && data?.enableAutoGeneration && !data?.enableManualEntry" pInputText type="text" formControlName="sequenceNumber"  disabled tooltipPosition="top" pTooltip="
                                    Displayed Lead ID No May Appear Different After Saving" />
                                    <input *ngIf="this.crudType === 'add' && data?.enableAutoGeneration && data?.enableManualEntry" pInputText type="text" formControlName="sequenceNumber" tooltipPosition="top" pTooltip="
                                    Displayed Lead ID No May Appear Different After Saving" />
                                    <input *ngIf="this.crudType === 'update'" pInputText type="text" formControlName="sequenceNumber"  disabled tooltipPosition="top" pTooltip="
                                    Displayed Lead ID No May Appear Different After Saving" />
                                    <input *ngIf="this.crudType === 'copy'" disabled pInputText type="text" formControlName="sequenceNumber" tooltipPosition="top" pTooltip="
                                    Displayed Lead ID No May Appear Different After Saving" />
                                </div>

                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.LeadName">
                                    <label class="p-mb-2">
                                        {{ checkedFields.LeadName?.labelName }}
                                        @if(checkedFields?.LeadName?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.LeadName?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }

                                    </label>
                                    <input pInputText type="text" formControlName="businessName" />
                                    <small id="error-help" class="p-invalid"
                                        *ngIf="leadForm?.get('businessName')?.errors?.required && leadForm?.get('businessName').touched">
                                        {{ checkedFields.LeadName?.labelName }} is required
                                    </small>
                                    <small class="p-invalid" *ngIf="leadForm?.get('businessName')?.errors?.maxlength && leadForm?.get('businessName').touched">
                                        Max 100 characters
                                    </small>
                                    <small class="p-invalid p-mt-2" *ngIf="leadForm?.get('businessName')?.errors?.pattern && leadForm?.get('businessName').touched">
                                        Colon (:) is not allowed
                                    </small>
                                </div>
                            </div>

                            <div *ngIf="checkedFields.LeadOwner" class="p-field p-grid">
                                <div class="p-col-12 p-lg-6">
                                    <label class="p-mb-2">
                                        {{ checkedFields.LeadOwner?.labelName || 'Lead Owner' }}
                                        <span style="color: red;">*</span>
                                        @if(checkedFields?.LeadOwner?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.LeadOwner?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <p-dropdown [options]="activeUsers" formControlName="ownerId" optionLabel="name" placeholder="Select Lead Owner" [filter]="true" [filterBy]="'name'" appendTo="body">
                                    </p-dropdown>
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="checkedFields.LeadType || checkedFields.LeadNumber">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.LeadType">
                                    <label for="leadTypes" class="p-mb-2">
                                        {{ checkedFields.LeadType?.labelName }}
                                        @if(checkedFields?.LeadType?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.LeadType?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <p-multiSelect [options]="types" placeholder="Select Lead Type(s)" formControlName="selectedLeadTypes" dataKey="id" optionLabel="name" placeholder="Lead types" appendTo="body">
                                    </p-multiSelect>
                                </div>

                                <div class="p-col-6" *ngIf="checkedFields.LeadNumber">
                                    <label class="p-mb-2">
                                        {{ checkedFields.LeadNumber?.labelName }}
                                        @if(checkedFields?.LeadNumber?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.LeadNumber?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <input pInputText type="text" formControlName="leadNumber" />
                                    <small class="p-invalid" *ngIf="leadForm?.get('leadNumber')?.errors?.maxlength && leadForm?.get('leadNumber').touched">
                                        Max 50 characters
                                    </small>
                                </div>
                            </div>

                            <ng-container>
                                <div class="p-field p-grid" *ngIf="checkedFields.Timezone || checkedFields.Currency">
                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.Timezone">
                                        <label class="p-mb-2">
                                            {{ checkedFields.Timezone?.labelName }}
                                            @if(checkedFields?.Timezone?.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.Timezone?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <p-dropdown [options]="timeZoneList" name="timeZoneId" placeholder="Select Time Zone" inputId="timeZoneId" formControlName="timeZoneId" optionLabel="name" optionValue="id" appendTo="body">
                                        </p-dropdown>
                                    </div>

                                    <div class="p-col-12 p-lg-6" *ngIf="checkedFields.Currency">
                                        <label class="p-mb-2">
                                            {{ checkedFields.Currency?.labelName }}
                                            @if(checkedFields?.Currency?.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.Currency?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                        </label>
                                        <p-dropdown [options]="currencyList" id="currency" name="currency" placeholder="Select currency" appendTo="body" inputId="currency" formControlName="currencyId" dataKey="id" [filter]="true" [filterBy]="'name'" optionLabel="name">
                                        </p-dropdown>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container>
                                <div *ngIf="checkedFields.Tags" class="p-field p-grid">
                                    <div class="p-col-12">
                                        <label>Tags
                                            @if(checkedFields?.Tags?.description){
                                                <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                   pTooltip="{{checkedFields.Tags?.description}}"
                                                   tooltipPosition="top">
                                                </i>
                                            }
                                            <span class="btnBars" (click)="addTag()"><i class="pi pi-plus"></i></span>
                                        </label>
                                        <ng-container *ngFor="let s of tags; let i = index">
                                            <p-tag class="p-ml-2" [style]="{'background-color': s.color}">
                                                <div style="display: flex;padding: 2px;" (click)="removeTag(i)">
                                                    <div>{{s.name}}</div>
                                                    <div class="crossIconAlignment"><i style="font-size: 8px;" class="pi pi-times"></i></div>
                                                </div>
                                            </p-tag>
                                        </ng-container>
                                    </div>
                                </div>

                            </ng-container>

                            <app-shared-custom-fields-template [selectedCustomFields]="leadInfoCustomFields" [isSubmitted]="isSubmitted" [tabIndex]="0">
                            </app-shared-custom-fields-template>
                        </div>
                    </p-tabPanel>

                    <p-tabPanel [header]="templateSections && templateSections[2]?.name">
                        <div class="card">
                            <div class="p-field p-grid" *ngIf="checkedFields.DoingBusinessas || checkedFields.TaxID">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.DoingBusinessas">
                                    <label class="p-mb-2">
                                        {{ checkedFields.DoingBusinessas?.labelName }}
                                        @if(checkedFields?.DoingBusinessas?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.DoingBusinessas?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <input pInputText type="text" formControlName="doingBusinessAs" />
                                    <small class="p-invalid details-error" *ngIf="leadForm?.get('doingBusinessAs')?.errors?.maxlength && leadForm?.get('doingBusinessAs').touched">
                                        Max 50 characters
                                    </small>
                                </div>

                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.TaxID">
                                    <label class="p-mb-2">
                                        {{ checkedFields.TaxID?.labelName }}
                                        @if(checkedFields?.TaxID?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.TaxID?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <input pInputText type="text" formControlName="taxId" />
                                    <small class="p-invalid details-error" *ngIf="leadForm?.get('taxId')?.errors?.maxlength && leadForm?.get('taxId').touched">
                                        Max 50 characters
                                    </small>
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="checkedFields.NumberofEmployees || checkedFields.EstimatedAnnualRevenue">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.NumberofEmployees ">
                                    <label class="p-mb-2">
                                        {{ checkedFields.NumberofEmployees?.labelName }}
                                        @if(checkedFields?.NumberofEmployees?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.NumberofEmployees?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <p-dropdown [options]="employees" name="employeesRange" placeholder="Select Employee" inputId="employeesRange" formControlName="employeesRangeId" optionLabel="name" dataKey="id" appendTo="body">
                                    </p-dropdown>
                                </div>

                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.EstimatedAnnualRevenue">
                                    <label for="annualRevenue" class="p-mb-2">
                                        {{ checkedFields.EstimatedAnnualRevenue?.labelName }}
                                        @if(checkedFields?.EstimatedAnnualRevenue?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.EstimatedAnnualRevenue?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <p-dropdown [options]="revenues" placeholder="Select Revenue" name="annualRevenue" inputId="annualRevenue" formControlName="annualRevenueId" optionLabel="name" dataKey="id" appendTo="body">
                                    </p-dropdown>
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="checkedFields.OwnershipType || checkedFields.Stage">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.OwnershipType">
                                    <label class="p-mb-2">
                                        {{ checkedFields.OwnershipType?.labelName }}
                                        @if(checkedFields?.OwnershipType?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.OwnershipType?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <p-dropdown [options]="ownerships" name="ownerShipType" placeholder="Select ownership" inputId="ownership" formControlName="ownerShipType" optionLabel="name" dataKey="id" [filter]="true" filterBy="name" appendTo="body">
                                    </p-dropdown>
                                </div>

                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.CurrentStage">
                                    <label class="p-mb-2">
                                        {{ checkedFields.CurrentStage?.labelName }}
                                        @if(checkedFields?.CurrentStage?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.CurrentStage?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <p-dropdown [options]="stages" placeholder="Select lead stage" inputId="leadStageId" formControlName="leadStageId" optionLabel="name" optionValue="id" [filter]="true" [filterBy]="'name'" appendTo="body" (onChange)="setStageOwnerAccordingToStage($event.value)">
                                    </p-dropdown>
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="leadOwnerSettings?.enabled">
                                <div class="p-col-12 p-lg-6">
                                    <label for="name">Current Stage Owner</label>
                                    <p-dropdown [options]="activeUsers" placeholder="Select lead stage Owner" inputId="stageOwnerId" formControlName="stageOwnerId" optionLabel="name" optionValue="id" [filter]="true" [filterBy]="'name'" appendTo="body" (onChange)="onSelectStageOwner($event.value)">
                                    </p-dropdown>
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="crudType == 'update'">
                                <div class="p-col-12 p-lg-6" *ngIf="stageCommentEnable && crudType != 'add'">
                                    <label class="p-mb-2">
                                        Comment
                                    </label>
                                    <textarea pInputTextarea name="description" formControlName="comment" rows="2"></textarea>
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="checkedFields.FoundedYear || checkedFields.Industry">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.FoundedYear">
                                    <label class="p-mb-2">
                                        {{ checkedFields.FoundedYear?.labelName }}
                                        @if(checkedFields?.FoundedYear?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.FoundedYear?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <input pInputText type="text" formControlName="foundedYear" />
                                    <small class="p-invalid details-error" *ngIf="leadForm?.get('foundedYear')?.errors?.maxlength && leadForm?.get('foundedYear').touched">
                                        Max 15 characters
                                    </small>
                                </div>

                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.Industry">
                                    <label class="p-mb-2">
                                        {{ checkedFields.Industry?.labelName }}
                                        @if(checkedFields?.Industry?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.Industry?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <p-dropdown [options]="industries" formControlName="industry" placeholder="Select Industry" optionLabel="name" name="industry" dataKey="id" inputId="industry" [filter]="true" [filterBy]="'name'" appendTo="body">
                                    </p-dropdown>
                                </div>
                            </div>

                            <div class="p-field p-grid p-mb-3" *ngIf="checkedFields.LeadEmail || checkedFields.LeadPhone">
                                <div class="p-col-6" *ngIf="leadEmails.length">
                                    <label class="p-mb-2">
                                        {{ checkedFields.LeadEmail?.labelName }}
                                        @if(checkedFields?.LeadEmail?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.LeadEmail?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <div>
                                        <span class="p-input-icon-left" style="width: 100%; position: relative;">
                                            <i [pTooltip]="checkedFields.LeadEmail?.labelName" tooltipPosition="top"
                                                class="pi pi-envelope">
                                            </i>
                                            <input pInputText type="email" [ngModelOptions]="{standalone: true}"
                                                #leademailn="ngModel" asyncEmailValidator [leadId]="leadForm.value?.id"
                                                pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                                [(ngModel)]="leadEmails[0].email.emailAddress" />
                                        </span>
                                    </div>
                                    <div class="p-mt-2" *ngIf="leadEmails.length">
                                        <div *ngIf="leadEmails[0].email?.emailAddress?.length > 100">
                                            <small class="p-invalid details-error">
                                                Max 100 characters
                                            </small>
                                        </div>
                                        <div *ngIf="leademailn?.errors?.pattern">
                                            <small class="p-invalid details-error">
                                                Invalid email format
                                            </small>
                                        </div>
                                        <div *ngIf="leademailn.errors?.emailExists">
                                            <small class="p-invalid details-error">
                                                This email already added, please enter another email
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="p-col-6 p-pt-1" *ngIf="leadPhones.length">
                                    <div class="p-grid">
                                        <div class="p-col-12 p-lg-4">
                                            <label class="p-mb-2">Select Country</label>
                                            <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                                optionLabel="CountryName"
                                                optionValue="CountryName"
                                                [autoDisplayFirst]="false"
                                                [(ngModel)]="leadPhones[0].phone.country"
                                                placeholder="Select Country"
                                                [ngModelOptions]="{standalone: true}"
                                                (onChange)="onCountrySelect($event, leadPhones[0])"
                                                class="inline" appendTo="body">
                                            </p-dropdown>
                                        </div>
                                        <div class="p-col-12 p-lg-8">
                                            <label class="p-mb-2">
                                                {{ checkedFields.LeadPhone?.labelName }}
                                                @if(checkedFields?.LeadPhone?.description){
                                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                                       pTooltip="{{checkedFields.LeadPhone?.description}}"
                                                       tooltipPosition="top">
                                                    </i>
                                                }
                                            </label>
                                            <div class="p-inputgroup">
                                                <span class="p-inputgroup-addon">+{{leadPhones[0].phone.code}}</span>
                                                <p-inputMask *ngIf="phoneNumberFormat && !leadPhones[0]?.phone?.maskingDisabled" [mask]="phoneNumberFormat" #leadPhonen="ngModel" [(ngModel)]="leadPhones[0].phone.number"
                                                [ngModelOptions]="{standalone: true}" [slotChar]="'_'" [autoClear]="false" class="w-100"></p-inputMask>
                                                <input *ngIf="!(phoneNumberFormat && !leadPhones[0]?.phone?.maskingDisabled)" pInputText type="text" #leadPhonen="ngModel" [ngModelOptions]="{standalone: true}"
                                                    [(ngModel)]="leadPhones[0].phone.number" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="p-pl-1 p-mt-1" *ngIf="leadPhonen?.invalid">
                                        <small class="p-invalid details-error">
                                            Invalid phone format
                                        </small>
                                    </div>
                                    <div class="p-pl-1 p-mt-1" *ngIf="leadPhones[0]?.phone?.number | phoneValidation">
                                        <small class="p-invalid details-error">
                                            Max 50 characters
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="p-field p-grid p-mb-3">
                                <div class="p-col-12 p-lg-6 p-mb-3" *ngIf="checkedFields.LeadWebsite">
                                    <label class="p-mb-2">
                                        {{ checkedFields.LeadWebsite?.labelName }}
                                        @if(checkedFields?.LeadWebsite?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.LeadWebsite?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <input pInputText type="text" placeholder="URL" [ngModelOptions]="{standalone: true}" [(ngModel)]="leadWebsite.socialProfile.name">
                                    <div *ngIf="leadWebsite?.socialProfile?.name?.length > 500">
                                        <small class="p-invalid details-error">
                                            Max 500 characters
                                        </small>
                                    </div>
                                </div>

                                <div class="p-col-12 p-lg-6 p-mb-3" *ngIf="checkedFields.LeadTwitter">
                                    <label class="p-mb-2">
                                        {{ checkedFields.LeadTwitter?.labelName }}
                                        @if(checkedFields?.LeadTwitter?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.LeadTwitter?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <input pInputText type="text" placeholder="URL" [ngModelOptions]="{standalone: true}" [(ngModel)]="leadTwitter.socialProfile.name">
                                    <div *ngIf="leadTwitter?.socialProfile?.name?.length > 500">
                                        <small class="p-invalid details-error">
                                            Max 500 characters
                                        </small>
                                    </div>
                                </div>

                                <div class="p-col-12 p-lg-6 p-mb-3" *ngIf="checkedFields.LeadFacebook">
                                    <label class="p-mb-2">
                                        {{ checkedFields.LeadFacebook?.labelName }}
                                        @if(checkedFields?.LeadFacebook?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.LeadFacebook?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <input pInputText type="text" placeholder="URL" [ngModelOptions]="{standalone: true}" [(ngModel)]="leadFacebook.socialProfile.name">
                                    <div *ngIf="leadFacebook?.socialProfile?.name?.length > 500">
                                        <small class="p-invalid details-error">
                                            Max 500 characters
                                        </small>
                                    </div>
                                </div>

                                <div class="p-col-12 p-lg-6 p-mb-3" *ngIf="checkedFields.LeadLinkedin">
                                    <label class="p-mb-2">
                                        {{ checkedFields.LeadLinkedin?.labelName }}
                                        @if(checkedFields?.LeadLinkedin?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.LeadLinkedin?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <input pInputText type="text" placeholder="URL" [ngModelOptions]="{standalone: true}" [(ngModel)]="leadLinkedin.socialProfile.name">
                                    <div *ngIf="leadLinkedin?.socialProfile?.name?.length > 500">
                                        <small class="p-invalid details-error">
                                            Max 500 characters
                                        </small>
                                    </div>
                                </div>

                                <div class="p-col-12 p-lg-6 p-mb-3" *ngIf="checkedFields.LeadInstagram">
                                    <label class="p-mb-2">
                                        {{ checkedFields.LeadInstagram?.labelName }}
                                        @if(checkedFields?.LeadInstagram?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.LeadInstagram?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <input pInputText type="text" placeholder="URL" [ngModelOptions]="{standalone: true}" [(ngModel)]="leadInstagram.socialProfile.name">
                                    <div *ngIf="leadInstagram?.socialProfile?.name?.length > 500">
                                        <small class="p-invalid details-error">
                                            Max 500 characters
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="checkedFields.SICCode || checkedFields.NAICSCode">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.SICCode">
                                    <label class="p-mb-2">
                                        {{ checkedFields.SICCode?.labelName }}
                                        @if(checkedFields?.SICCode?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.SICCode?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <input pInputText type="text" formControlName="sicCode" />
                                </div>

                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.NAICSCode">
                                    <label class="p-mb-2">
                                        {{ checkedFields.NAICSCode?.labelName }}
                                        @if(checkedFields?.NAICSCode?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.NAICSCode?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <input pInputText type="text" formControlName="naicsCode" />
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="checkedFields.LeadSource || checkedFields.Rating">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.LeadSource">
                                    <label class="p-mb-2">
                                        {{ checkedFields.LeadSource?.labelName }}
                                        @if(checkedFields?.LeadSource?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.LeadSource?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <p-dropdown [options]="sources" name="sourceId" placeholder="Select Lead Source" inputId="sourceId" formControlName="sourceId" dataKey="id" optionLabel="name" [filter]="true" [filterBy]="'name'" appendTo="body">
                                    </p-dropdown>
                                </div>

                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.Rating">
                                    <label class="p-mb-2">
                                        {{ checkedFields.Rating?.labelName }}
                                        @if(checkedFields?.Rating?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.Rating?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                        </label>
                                    <p-dropdown [options]="ratings" name="ratingId" placeholder="Select Rating" inputId="ratingId" formControlName="ratingId" dataKey="id" optionLabel="name" [filter]="true" [filterBy]="'name'" appendTo="body">
                                    </p-dropdown>
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="checkedFields.LeadQuality || checkedFields.BusinessCard">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.LeadQuality">
                                    <label class="p-mb-2">
                                        {{ checkedFields.LeadQuality?.labelName }}
                                        @if(checkedFields?.LeadQuality?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.LeadQuality?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <p-dropdown [options]="status" name="leadStatusId" placeholder="Select Quality" inputId="leadStatusId" formControlName="leadStatusId" optionLabel="name" optionValue="id" [filter]="true" [filterBy]="'name'" appendTo="body">
                                    </p-dropdown>
                                </div>

                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.BusinessCard">
                                    <label class="p-mb-2">
                                        {{ checkedFields.BusinessCard?.labelName }}
                                        @if(checkedFields?.BusinessCard?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.BusinessCard?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>

                                    <p-fileUpload [ngClass]="{ 'disabledbutton': !isEditAccount }" customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose" accept="image/*" [showUploadButton]="false" [disabled]="!isEditAccount" [showCancelButton]="false" (onSelect)="uploadBusinessCard($event.files)">
                                        <ng-template pTemplate="file"></ng-template>
                                        <ng-template pTemplate="content">
                                            <ng-container *ngIf="selectedcontactBusinessCards">
                                                <ng-container *ngFor="let profileImg of selectedcontactBusinessCards; let i = index;">
                                                    <ng-container *ngIf="profileImg.attachment && profileImg.attachment.statusId === 1">
                                                        <div class="p-fileupload-row">
                                                            <button pButton icon="fa fa-download" (click)="downloadFile(profileImg.attachment.name, profileImg.attachment.content, profileImg.attachment.location)" class="p-button-link p-px-0 p-py-0" label=""></button>
                                                            <ng-container *ngIf="profileImg.attachment && profileImg.attachment.content && profileImg.attachment.content.startsWith('data') else localImage">
                                                                <img src="{{profileImg.attachment.content}}" width="100" alt="card" />
                                                            </ng-container>
                                                            <ng-template #localImage>
                                                                <img [src]="profileImg.attachment.location" width="100" alt="card" />
                                                            </ng-template>
                                                            <div>{{ profileImg.attachment.name }}</div>
                                                            <div>{{ (profileImg.attachment.sizeInBytes / 1024).toFixed(2) + ' KB' }}</div>
                                                            <div>
                                                                <button icon="pi pi-times" pButton [disabled]="!isEditAccount" (click)="removeBusinessCard(i)" type="button" icon="pi pi-times"></button>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </ng-template>
                                    </p-fileUpload>
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="checkedFields.Notes">
                                <div class="p-col-12">
                                    <label class="p-mb-2">
                                        {{ checkedFields.Notes?.labelName }}
                                        @if(checkedFields?.Notes?.description){
                                            <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip" 
                                               pTooltip="{{checkedFields.Notes?.description}}"
                                               tooltipPosition="top">
                                            </i>
                                        }
                                    </label>
                                    <textarea pInputTextarea name="description" formControlName="description" rows="2"></textarea>
                                </div>
                            </div>

                            <app-shared-custom-fields-template [selectedCustomFields]="leadDetailsCustomFields" [isSubmitted]="isSubmitted" [tabIndex]="1">
                            </app-shared-custom-fields-template>
                        </div>
                    </p-tabPanel>

                    <p-tabPanel [header]="templateSections && templateSections[3]?.name">
                        <app-lion-address-grid [addressList]="accountTempAddress" [countries]="countries" [contactListAttn]="contactListAttn"
                        [selectedObjectRecord]="selectedAccount" [allowEdit]="isEditAccount" [accountAddressTypes]="accountAddressTypes"
                        [addressClasses]="addressClasses" [overViewPage]="false" mappingField="leadId" [checkedFields]="checkedFields"
                        [accountName]="leadForm?.get('businessName').value" [firstName]="formControl?.contact?.get('firstName').value"
                        [lastName]="formControl?.contact?.get('lastName').value" [moduleId]="leadModuleId" (onUpdateAddressList)="onUpdateAddressList($event)">
                        </app-lion-address-grid>
                    </p-tabPanel>

                    <!-- Custom Section -->
                    <ng-container *ngFor="let customSection of customSections; let i = index">
                        <p-tabPanel *ngIf="customSection && customSection?.customFields?.length > 0" [header]="customSection?.name">
                            <app-shared-custom-fields-template
                                [tabIndex]="(3+i)"
                                [selectedCustomFields]="customSectionFields[i]"
                                [isSubmitted]="isSubmitted">
                            </app-shared-custom-fields-template>
                        </p-tabPanel>
                    </ng-container>
                    <!-- End Custom Section -->

                    <!-- <p-tabPanel header="Communication Pref.">
                        <div class="p-field-checkbox">
                            <p-checkbox name="communication" value="Don't Call" [(ngModel)]="selectedCommunication" inputId="notCall"></p-checkbox>
                            <label for="notCall">Do not Call</label>
                        </div>
                        <div class="p-field-checkbox">
                            <p-checkbox name="communication" value="Don't Email" [(ngModel)]="selectedCommunication" inputId="notEmail"></p-checkbox>
                            <label for="sf">Do not Email</label>
                        </div>
                        <div class="p-field-checkbox">
                            <p-checkbox name="communication" value="Don't Text" [(ngModel)]="selectedCommunication" inputId="notText"></p-checkbox>
                            <label for="la">Do not Text</label>
                        </div>
                    </p-tabPanel> -->
                </p-tabView>

                <ng-template #leadViewBlock>
                    <div class="header">
                        <h5>
                            {{ templateSections && templateSections[1]?.name }}
                        </h5>
                    </div>

                    <div class="card">
                        <div class="p-field p-grid p-mb-0">
                            <ng-container *ngIf="checkedFields?.LeadIDNo && viewLeadData?.sequenceNumber">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields?.LeadIDNo?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4" *ngIf="viewLeadData?.sequenceNumber">
                                    <p> {{ viewLeadData?.sequenceNumber }} </p>
                                </div>
                            </ng-container>
                            <ng-container>
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.LeadName?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData?.businessName }} </p>
                                </div>
                            </ng-container>

                            <ng-container>
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.Status?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData?.status?.name }} </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="checkedFields.LeadOwner && viewLeadData?.ownerName">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.LeadOwner?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{viewLeadData?.ownerName}} </p>
                                </div>
                            </ng-container>


                            <ng-container *ngIf="checkedFields.LeadNumber && viewLeadData?.leadNumber">
                                <div class="p-col-4 p-md-2">
                                    <p>
                                        <strong> {{ checkedFields.LeadNumber?.labelName }} </strong>
                                    </p>
                                </div>
                                <div class="p-col-8 p-md-4">
                                    <p> {{ viewLeadData?.leadNumber }} </p>
                                </div>
                            </ng-container>
                        </div>

                        <ng-container *ngIf="showAccountInfoMore">
                            <div class="p-field p-grid p-mb-0">
                                <ng-container *ngIf="checkedFields.LeadType && viewLeadData?.leadTypes">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong> {{ checkedFields.LeadType?.labelName }} </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.leadTypes }} </p>
                                    </div>
                                </ng-container>


                                <ng-container *ngIf="checkedFields.Timezone && viewLeadData?.timezoneName">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong> {{ checkedFields.Timezone?.labelName }} </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.timezoneName }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.Currency && viewLeadData?.currency">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong> {{ checkedFields.Currency?.labelName }} </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4" *ngIf="viewLeadData?.currency">
                                        <p> {{ viewLeadData?.currency }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.Tags && viewLeadData.tags">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong> {{ checkedFields.Tags?.labelName }} </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4" *ngIf="viewLeadData?.tags">
                                        <span *ngFor="let tag of viewLeadData?.tags">
                                            <p-tag [value]="tag?.name" styleClass="p-ml-2" [style]="{'background-color': tag?.color}"></p-tag>
                                        </span>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>

                        <app-shared-custom-fields *ngIf="selectedLead?.customAttributeValues" [isEdit]="false" [templateCustomFields]="templateSections[1]?.customFields" [customFieldValues]="selectedLead?.customAttributeValues">
                        </app-shared-custom-fields>

                        <div class="p-field p-formgrid p-grid account-info-show-more">
                            <div class="p-col-12">
                                <button type="button" style="float: right;" pButton (click)="showAccountInfoMore = !showAccountInfoMore" label="{{ showAccountInfoMore ? 'Show Less' : 'Show More' }}" class="p-button-secondary">
                                </button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="showAccountInfoMore" class="p-mb-3">
                        <div class="header">
                            <h5>
                                {{ templateSections && templateSections[2]?.name }}
                            </h5>
                        </div>
                        <div class="card">
                            <div class="p-field p-grid p-mb-0">
                                <ng-container *ngIf="checkedFields.DoingBusinessas && viewLeadData?.doingBusinessAs">
                                    <div class="p-col-4 p-md-2">
                                        <p pTooltip="{{ checkedFields.DoingBusinessas?.labelName }}" tooltipPosition="top">
                                            <strong>
                                                {{ (checkedFields.DoingBusinessas?.labelName.length > 20 ) ?
                                                checkedFields.DoingBusinessas?.labelName.slice(0, 20) + '...'
                                                : checkedFields.DoingBusinessas?.labelName
                                                }}
                                            </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.doingBusinessAs }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.TaxID && viewLeadData?.taxId">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong> {{ checkedFields.TaxID?.labelName }} </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.taxId }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.NumberofEmployees && viewLeadData?.employeesRangeName">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong> {{ checkedFields.NumberofEmployees?.labelName }} </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.employeesRangeName }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.EstimatedAnnualRevenue && viewLeadData?.annualRevenueName">
                                    <div class="p-col-4 p-md-2">
                                        <p pTooltip="{{ checkedFields.EstimatedAnnualRevenue?.labelName }}" tooltipPosition="top">
                                            <strong>
                                                {{ (checkedFields.EstimatedAnnualRevenue?.labelName.length > 20 ) ?
                                                checkedFields.EstimatedAnnualRevenue?.labelName.slice(0, 20) + '...'
                                                : checkedFields.EstimatedAnnualRevenue?.labelName
                                                }}
                                            </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.annualRevenueName }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.OwnershipType && viewLeadData?.ownershipName">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong> {{ checkedFields.OwnershipType?.labelName }} </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.ownershipName }} </p>
                                    </div>
                                </ng-container>

                                <!-- <ng-container *ngIf="checkedFields.Stage && viewLeadData?.stageName">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong>
                                                {{ checkedFields.Stage?.labelName }}
                                            </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.stageName }} </p>
                                    </div>
                                </ng-container> -->

                                <!-- ----child -->
                                <ng-container *ngIf="checkedFields.PreviousStage && viewLeadData?.previousStage">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong>
                                                {{ checkedFields.PreviousStage?.labelName }}
                                            </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.previousStage }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.PreviousStageOwner && viewLeadData?.previousStageOwner">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong>
                                                {{ checkedFields.PreviousStageOwner?.labelName }}
                                            </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.previousStageOwner }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.CurrentStage && viewLeadData?.currentStage">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong>
                                                {{ checkedFields.CurrentStage?.labelName }}
                                            </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.currentStage }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.CurrentStageOwner && viewLeadData?.currentStageOwner">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong>
                                                {{ checkedFields.CurrentStageOwner?.labelName }}
                                            </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.currentStageOwner }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.StageChangedBy && viewLeadData?.stageChangedBy">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong>
                                                {{ checkedFields.StageChangedBy?.labelName }}
                                            </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.stageChangedBy }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.StageChangedDate && viewLeadData?.stageChangedDate">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong>
                                                {{ checkedFields.StageChangedDate?.labelName }}
                                            </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.stageChangedDate | localDate: 'date'}} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.FoundedYear && viewLeadData?.foundedYear">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong> {{ checkedFields.FoundedYear?.labelName }}</strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.foundedYear }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.Industry && viewLeadData?.industryName">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong> {{ checkedFields.Industry?.labelName }}</strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.industryName }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.LeadEmail && viewLeadData?.leadEmail">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong>
                                                {{ checkedFields.LeadEmail?.labelName }}
                                            </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <span>
                                            <i pTooltip="{{ checkedFields.LeadEmail?.labelName }}" tooltipPosition="top"
                                                class="pi pi-envelope">
                                            </i>
                                        </span> {{ viewLeadData?.leadEmail }}
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.LeadPhone && viewLeadData?.leadPhone">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong>
                                                {{ checkedFields.LeadPhone?.labelName }}
                                            </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <span>
                                            <i pTooltip="{{ checkedFields.LeadPhone?.labelName }}" tooltipPosition="top"
                                                class="pi pi-mobile">
                                            </i>
                                        </span> {{ viewLeadData?.leadPhone | phoneNumber: viewLeadData.leadPhoneCode }}
                                    </div>
                                </ng-container>

                                <ng-container>
                                    <ng-container *ngIf="checkedFields.LeadWebsite && viewLeadData?.leadWebsite">
                                        <div class="p-col-4 p-md-2">
                                            <p>
                                                <strong> {{ checkedFields.LeadWebsite?.labelName }} </strong>
                                            </p>
                                        </div>
                                        <div class="p-col-8 p-md-4">
                                            <p> {{ viewLeadData?.leadWebsite }} </p>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="checkedFields.LeadTwitter && viewLeadData?.leadTwitter">
                                        <div class="p-col-4 p-md-2">
                                            <p>
                                                <strong> {{ checkedFields.LeadTwitter?.labelName }} </strong>
                                            </p>
                                        </div>
                                        <div class="p-col-8 p-md-4">
                                            <p> {{ viewLeadData?.leadTwitter }} </p>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="checkedFields.LeadFacebook && viewLeadData?.leadFacebook">
                                        <div class="p-col-4 p-md-2">
                                            <p>
                                                <strong> {{ checkedFields.LeadFacebook?.labelName }} </strong>
                                            </p>
                                        </div>
                                        <div class="p-col-8 p-md-4">
                                            <p> {{ viewLeadData?.leadFacebook }} </p>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="checkedFields.LeadLinkedin && viewLeadData?.leadLinkedin">
                                        <div class="p-col-4 p-md-2">
                                            <p>
                                                <strong> {{ checkedFields.LeadLinkedin?.labelName }} </strong>
                                            </p>
                                        </div>
                                        <div class="p-col-8 p-md-4">
                                            <p> {{ viewLeadData?.leadLinkedin }} </p>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="checkedFields.LeadInstagram && viewLeadData?.leadInstagram">
                                        <div class="p-col-4 p-md-2">
                                            <p>
                                                <strong> {{ checkedFields.LeadInstagram?.labelName }} </strong>
                                            </p>
                                        </div>
                                        <div class="p-col-8 p-md-4">
                                            <p> {{ viewLeadData?.leadInstagram }} </p>
                                        </div>
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.SICCode && viewLeadData?.sicCode">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong> {{ checkedFields.SICCode?.labelName }} </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.sicCode }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.NAICSCode && viewLeadData?.naicsCode">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong> {{ checkedFields.NAICSCode?.labelName }} </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.naicsCode }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.LeadSource && viewLeadData?.sourceName">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong> {{ checkedFields.LeadSource?.labelName }} </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.sourceName }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.Rating && viewLeadData?.ratingName">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong> {{ checkedFields.Rating?.labelName }} </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.ratingName }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.LeadQuality && viewLeadData?.leadsStatus">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong> {{ checkedFields.LeadQuality?.labelName }} </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.leadsStatus }} </p>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.BusinessCard && viewLeadData.businessCardImages?.length">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong> {{ checkedFields.BusinessCard?.labelName }} </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <div *ngFor="let image of viewLeadData.businessCardImages" [pTooltip]="image.name" style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                                            <img [src]="image.downloadLink" width="100" alt="card" /> {{ image.name | shorten:15 }} ({{ image.sizeInKb + ' KB' }})
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="checkedFields.Notes && viewLeadData?.description">
                                    <div class="p-col-4 p-md-2">
                                        <p>
                                            <strong> {{ checkedFields.Notes?.labelName }} </strong>
                                        </p>
                                    </div>
                                    <div class="p-col-8 p-md-4">
                                        <p> {{ viewLeadData?.description }} </p>
                                    </div>
                                </ng-container>
                            </div>

                            <app-shared-custom-fields *ngIf="selectedLead?.customAttributeValues" [isEdit]="false" [templateCustomFields]="templateSections[2]?.customFields" [customFieldValues]="selectedLead?.customAttributeValues">
                            </app-shared-custom-fields>
                        </div>

                        <!-- Custom Section -->
                        <ng-container *ngFor="let customSection of customSectionsForView; let i = index">
                            <ng-container *ngIf="customSection && customSection?.customFields?.length > 0">
                                <div class="header">
                                    <h5>
                                        {{ customSection?.name }}
                                    </h5>
                                </div>
                                <div class="card">
                                    <app-shared-custom-fields
                                        [isEdit]="false"
                                        [templateCustomFields]="customSection?.customFields"
                                        [customFieldValues]="selectedAccount?.customAttributeValues">
                                    </app-shared-custom-fields>
                                </div>
                            </ng-container>
                        </ng-container>
                        <!-- End Custom Section -->
                    </div>

                    <app-lion-address-grid [moduleId]="leadModuleId" [overViewPage]="false" [checkedFields]="checkedFields"
                    [addressList]="selectedLead?.leadAddresses" [countries]="countries" [selectedObjectRecord]="selectedLead"
                    [allowEdit]="false" [accountAddressTypes]="addressTypes" [addressClasses]="addressClasses"
                    mappingField="leadId">
                    </app-lion-address-grid>

                    <app-shared-activities-timeline
                        [objectId]="selectedLead?.id"
                        [hideEmailSyncIcon]="selectedLead?.isConvertedToAccount"
                        [selectedObject]="selectedLead" objectType="Lead"
                        [hideRigthArrow]="true"
                        [fromAccountView]="true"
                        [isViewMode]="selectedLead?.statusId != 1">
                    </app-shared-activities-timeline>
                </ng-template>
            </form>
        </ng-container>
        <ng-container *ngIf="detailsLoadingFailed">
            <div class="card view-details-error-message">
                <span class="pi pi-exclamation-circle" style="font-size: 25px;"></span>
                <p>{{ detailsErrorMessage }}</p>
            </div>
        </ng-container>
    </ng-template>

    <p-footer>
        <button type="button" pButton (click)="onCancelAddEditView()" label="Cancel" class="p-button-secondary"></button>
        <button type="submit" pButton *ngIf="isEditAccount" (click)="verifyAndSubmitLead(leadForm.getRawValue(), 'view')" label="Save and View"></button>
        <button type="submit" pButton *ngIf="isEditAccount" (click)="verifyAndSubmitLead(leadForm.getRawValue(), 'save')" label="Save"></button>
    </p-footer>
</p-dialog>


<!-- Show tag list table -->
<ng-container *ngIf="displayAddTag">
    <app-assign-tag-dialog
        [showDialog]="displayAddTag"
        [selectedTags]="selectedValues"
        [tagList]="tagList"
        (assignedTag)="assignSelectedTags($event)"
        (addNewTag)="displayCreateTag = true"
        (closed)="displayAddTag = false">
    </app-assign-tag-dialog>
</ng-container>


<!-- Show add new tag dialog-->
<ng-container *ngIf="displayCreateTag">
    <app-add-tag-dialog
        [showDialog]="displayCreateTag"
        (clickSubmit)="createTag($event)"
        (closed)="displayCreateTag = false">
    </app-add-tag-dialog>
</ng-container>
